import "../../css/ModalXL.css";
import React, { Component } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { memo } from 'react';

export class ModalXL extends Component {

  render() {

      return (
          !this.props.modalXXL ?
              /*SECCION MODALXL*/
            <div className="modalXL-background">
                <div className="modalXL-container">
                <div className="modalXL-header1">
                  <button className="modalXL-close" onClick={this.props.cerrarModal} >
                    x
                  </button>
                </div>
                {this.props.children}
                    {this.props.verBoton ? (<div className="modalXL-container-botonGuardar">
                        <button className='modalXL-btn-submit' onClick={this.props.cerrarModal}>{this.props.textoBoton}</button>
                </div>):null}
              </div>
          
          
              </div> :

              <div className="modalXXL-background">
                  <div className="modalXXL-container">
                      <div className="modalXXL-header1">
                          <button className="modalXXL-close" onClick={this.props.cerrarModal} >
                              X
                          </button>
                      </div>
                      {this.props.children}
                      {this.props.verBoton ? (<div className="modalXXL-container-botonGuardar">
                          <button className='modalXXL-btn-submit' onClick={this.props.cerrarModal}>{this.props.textoBoton}</button>
                      </div>) : null}
                  </div>
              </div>
      
    )
  }
}

export default memo(ModalXL);